var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "bg-white overflow-hidden ring-1 ring-black ring-opacity-5",
    },
    [
      _vm.title
        ? _c(
            "div",
            { staticClass: "px-6 py-1.5 pt-0 flex flex-row -mt-1" },
            [
              _vm._t("title", function () {
                return [
                  _c(
                    "p",
                    {
                      staticClass:
                        "xl:text-lg font-normal capitalize text-primary-black",
                    },
                    [_vm._v(" " + _vm._s(_vm.title) + " ")]
                  ),
                  _vm.total && _vm.total > 0
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "text-gray-new text-base font-normal text-sm",
                        },
                        [_vm._v("(" + _vm._s(_vm.total) + ") ")]
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "flex text-gray-800",
          class: _vm.contentHorizontalPadding,
        },
        [
          _vm._t("prefix", function () {
            return [_c("p", [_vm._v(" " + _vm._s(_vm.prefix) + " ")])]
          }),
          _c(
            "div",
            { staticClass: "w-full text-gray-800 pt-1 pb-4" },
            [
              _vm._t("default", function () {
                return [
                  _vm.content
                    ? _c("p", { staticClass: "truncate" }, [
                        _vm._v(" " + _vm._s(_vm.content) + " "),
                      ])
                    : _c("p", { staticClass: "text-gray-400" }, [
                        _vm._v(" " + _vm._s(_vm.placeholder) + " "),
                      ]),
                ]
              }),
            ],
            2
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }